import React, { useState, useEffect } from 'react';
import { Tabs, Box, Container, SpaceBetween } from '@amzn/awsui-components-react';
import { useParams } from 'react-router-dom';

/**
 * Main tab bar for the app details page.
 *
 * `extraTabs` ([{ id, label }]) appends page-supplied tabs after the static
 * ones — today the Task Manager dashboards associated with the app. They are
 * hidden in edit mode along with every other non-details tab; the caller owns
 * rendering their content, so only the id/label are needed here.
 */
const MenuBar = ({ onTabChange, activeTab, activeSubTab, isEditMode, shouldNotShowResults, extraTabs = [] }) => {
  const { id: appId } = useParams();
  const [activeMainTab, setActiveMainTab] = useState(activeTab || 'actions');
  const [activeSecondaryTab, setActiveSecondaryTab] = useState(activeSubTab || 'upload');

  const allTabs = [
    { 
      id: 'details', 
      label: 'Details and Meta',
      content: <Box></Box>
    },
    { 
      id: 'results', 
      label: 'Results',
      content: <Box></Box>
    },
    { 
      id: 'actions', 
      label: 'Actions',
      content: <Box></Box>
    },
    { 
      id: 'approvals', 
      label: 'App Approvals',
      content: <Box></Box>
    },
    { 
      id: 'audit', 
      label: 'Audit Logs',
      content: <Box></Box>
    }
  ];

  // Page-supplied tabs (Task Manager dashboards); content is rendered by the page.
  const dynamicTabs = (extraTabs || []).map(tab => ({
    id: tab.id,
    label: tab.label,
    content: <Box></Box>
  }));

  // Filter tabs based on edit mode
  let mainTabs = isEditMode
    ? allTabs.filter(tab => tab.id === 'details')
    : [...allTabs, ...dynamicTabs];

  // Filter tabs based on output types 
  mainTabs = shouldNotShowResults 
    ? mainTabs.filter(tab => tab.id != 'results')
    : mainTabs;

  const handleMainTabClick = (tabId) => {
    // appId is now available from useParams hook
    // Remove redirects for both approvals and audit tabs - let parent handle them
    setActiveMainTab(tabId);
    onTabChange?.(tabId, null);
  };

  const handleSecondaryTabClick = (tabId) => {
    setActiveSecondaryTab(tabId);
    onTabChange?.(activeMainTab, tabId);
  };

  useEffect(() => {
    if (activeTab !== activeMainTab) {
      setActiveMainTab(activeTab);
    }
    if (activeSubTab !== activeSecondaryTab) {
      setActiveSecondaryTab(activeSubTab);
    }
  }, [activeTab, activeSubTab]);

  return (
    <Box>
      {/* <SpaceBetween direction="vertical" size="m"> */}
        <Tabs
          onChange={({ detail }) => handleMainTabClick(detail.activeTabId)}
          activeTabId={activeMainTab}
          tabs={mainTabs}
          variant="default"
          disableContentPaddings={true}
        />
      {/* </SpaceBetween> */}
    </Box>
  );
};

export default MenuBar;
